export const ARROW_HEIGHT = 5.5;
export const ARROW_WIDTH = 11;
export const TRANSITION_MS = 150;
